import postRequest from '../../../../../../postRequest';

/**
 * Bulk upload product name.
 *
 * @param {number} SiteId Site Id
 * @param {file} File Either a csv or excel file
*/
export default function postPreReleaseProductsProductId({
  SiteId,
  File,
}) {
  const endpoint = '/oc-product-bulkapi/v1/bulk-process/pre-release-product-file-upload';

  const body = new FormData();
  body.append('SiteId', SiteId);
  body.append('File', File);

  return new Promise((resolve, reject) => {
    postRequest(
      endpoint,
      body,
      'Pre Release Dates (ProductID)',
      'STARTED: Pre Release Dates File Upload',
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
